if (!customElements.get("m-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".m-tab-content"],
      };
      this.tabSliders = [];
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.items;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Check for Recently Viewed tab and load products
      const recentlyViewedTab = this.querySelector('[data-tab-type="recently-viewed"]');
      if (recentlyViewedTab) {
        this.loadRecentlyViewedProducts(recentlyViewedTab);
      }

      if (this.sliderEnabled) {
        for (let block of this.domNodes.tabContent) {
          this.initSliderByScreenSize(block);
          document.addEventListener("matchMobile", () => {
            this.initSliderByScreenSize(block);
          });
          document.addEventListener("unmatchMobile", () => {
            this.initSliderByScreenSize(block);
          });
        }
      }
      if (!this.sliderEnabled && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;

        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;
        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      document.addEventListener("matchMobile", () => {
        if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
          this.canLoad = true;
          this.currentPage = 1;
          for (let block of this.domNodes.tabContent) {
            this.initLoadMore(block);
          }
        }
      });
      this.initTabs();
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const blockSelectedIsTab = event.target.classList.contains("m-tab-content");
          if (!blockSelectedIsTab) return;
          const dataIndex = event.target && event.target.dataset.index;
          this.tabs.setActiveTab(dataIndex);
        });
      }
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, (target) => {
        const tabId = target.getAttribute("href");
        const tabElement = this.querySelector(tabId);
        
        // Eğer Recently Viewed tab'ı ise ve henüz yüklenmemişse yükle
        if (tabElement && tabElement.dataset.tabType === "recently-viewed") {
          const container = tabElement.querySelector("[data-recently-viewed-container]");
          if (container && container.children.length === 0) {
            this.loadRecentlyViewedProducts(tabElement);
          }
        }
        
        const slider = this.querySelector(tabId + " .swiper-container");
        const controlsContainer = this.querySelector(tabId + " .m-slider-controls");
        // trigger update slider
        slider && slider.swiper && slider.swiper.update();
        const firstItem = slider && (slider.querySelector(".m-image") || slider.querySelector(".m-placeholder-svg"));
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
        }
      });
    }

    initSliderByScreenSize(sliderContainer) {
      const mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      const slider = sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainer = sliderContainer.querySelector(".m-slider-controls");

      if (!slider) return;

      if (MinimogTheme.config.mqlMobile && mobileDisableSlider) {
        controlsContainer && controlsContainer.classList.add("m:hidden");
        slider.classList.remove("swiper-container");
        if (slider.swiper) slider.swiper.destroy(false, true);
      } else {
        // Slider'ın aktif olup olmadığını kontrol et
        const innerContainer = sliderContainer.querySelector(".m-mixed-layout__inner");
        const isSwiperWrapper = innerContainer && innerContainer.classList.contains("swiper-wrapper");
        
        if (isSwiperWrapper && innerContainer.children.length > 0) {
          controlsContainer && controlsContainer.classList.remove("m:hidden");
          setTimeout(() => {
            this.initSlider(sliderContainer);
          });
        } else {
          // Grid layout - slider kontrollerini gizle
          controlsContainer && controlsContainer.classList.add("m:hidden");
        }
      }
    }

    initSlider(sliderContainer) {
      const layoutWrapper = sliderContainer.querySelector(".m-product-list");
      const swiper = sliderContainer && sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainer = sliderContainer.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength =
        sliderContainer &&
        sliderContainer.querySelector(".swiper-wrapper") &&
        sliderContainer.querySelector(".swiper-wrapper").childElementCount;
      
      if (!swiper || !slideItemsLength || slideItemsLength === 0) {
        return;
      }
      
      if (parseInt(this.items) >= slideItemsLength) {
        controlsContainer && controlsContainer.classList.add("m:hidden");
        layoutWrapper && layoutWrapper.classList.add("m-mixed-layout--mobile-grid");
        return;
      }

      // Mevcut slider'ı destroy et
      if (swiper.swiper) {
        swiper.swiper.destroy(false, true);
      }

      swiper.classList.add("swiper-container");

      let slider = new MinimogLibs.Swiper(swiper, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: this.enableFlashsale ? false : true,
        pagination: this.showPagination
          ? {
              el: sliderContainer.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          992: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              // Calculate controls position
              const firstItem =
                sliderContainer.querySelector(".m-image") || sliderContainer.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => slider.slideNext());
      }
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
        const slider = this.tabs && this.tabs.currentTab && this.tabs.currentTab.querySelector(".swiper-container");
        const controlsContainer =
          this.tabs && this.tabs.currentTab && this.tabs.currentTab.querySelector(".m-slider-controls");
        const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
        const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
        slider && slider.swiper && slider.swiper.update();
        const firstItem = slider && slider.querySelector(".m-image");
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

          prevButton.classList.remove("m:hidden");
          nextButton.classList.remove("m:hidden");
        }
      });
    }

    initLoadMore(wrapper) {
      addEventDelegate({
        context: wrapper,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore(wrapper);
        },
      });
    }

    handleLoadMore(wrapper) {
      const loadBtn = wrapper.querySelector(this.selectors.loadMoreBtn);
      const productsContainer = wrapper.querySelector(this.selectors.productsContainer);

      let currentPage = wrapper.dataset.page;
      currentPage = parseInt(currentPage);
      const totalPages = wrapper.dataset.totalPages;
      this.toggleLoading(loadBtn, true);

      const url = wrapper.dataset.url;
      const dataUrl = `${url}?page=${currentPage + 1}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        currentPage++;
        wrapper.dataset.page = currentPage;
        this.toggleLoading(loadBtn, false);
        const dom = generateDomFromString(html);
        const tabId = wrapper.getAttribute("id");
        const products = dom.querySelector(`#${tabId} ${this.selectors.productsContainer}`);

        if (products) {
          Array.from(products.childNodes).forEach((product) => productsContainer.appendChild(product));
        }

        if (currentPage >= parseInt(totalPages)) loadBtn && loadBtn.remove();
      });

      // Remove button focus
      loadBtn.blur();
    }

    toggleLoading(loadBtn, status) {
      if (!loadBtn) return;
      if (status) {
        loadBtn.classList.add("m-spinner-loading");
      } else {
        loadBtn.classList.remove("m-spinner-loading");
      }
    }

    loadRecentlyViewedProducts(tabElement) {
      const queryString = this.getRecentlyViewedQueryString(tabElement);
      
      // Eğer query string boşsa (localStorage'da ürün yoksa), hiçbir şey yapma
      if (!queryString || queryString.trim() === "") {
        return;
      }
      
      // Önce simple-tabs section'ının kendi ID'sini kullan (May Also Like ile aynı kart yapısı için)
      // Eğer tabElement'te section ID varsa onu kullan, yoksa m-recently-viewed elementine bak
      let sectionId = tabElement.dataset.sectionId;

      if (!sectionId) {
        const recentlyViewedElement = document.querySelector("m-recently-viewed");
        if (recentlyViewedElement && recentlyViewedElement.dataset.sectionId) {
          sectionId = recentlyViewedElement.dataset.sectionId;
        } else {
          sectionId = "recent-viewed-products";
        }
      }
      
      const baseUrl = `${window.MinimogSettings?.routes?.search_url || "/search"}?section_id=${sectionId}&type=product&q=`;
      const fullUrl = baseUrl + queryString;
      
      fetch(fullUrl)
        .then((response) => response.text())
        .then((text) => {
          // Response'u DOMParser ile parse et
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          
          // Önce shopify-section içindeki içeriği bul
          let sectionElement = doc.querySelector(`#shopify-section-${sectionId}`);
          if (!sectionElement) {
            sectionElement = doc.querySelector(`[id*="${sectionId}"]`);
          }
          if (!sectionElement) {
            const allSections = doc.querySelectorAll('[id^="shopify-section-"]');
            if (allSections.length > 0) {
              sectionElement = allSections[0];
            }
          }
          
          if (sectionElement) {
            // Section içindeki m-recently-viewed'i ara
            const recommendations = sectionElement.querySelector("m-recently-viewed");
            
            if (recommendations) {
              const html = document.createElement("div");
              html.innerHTML = sectionElement.innerHTML;
              const allProductCards = html.querySelectorAll(".m-product-card");
              
              if (allProductCards.length > 0) {
                this.renderProductCards(allProductCards, tabElement, queryString);
                return;
              }
            }
          }
          
          // Eğer m-recently-viewed yoksa, direkt tüm response'da product card'ları ara
          const allProductCards = doc.querySelectorAll(".m-product-card");
          
          if (allProductCards.length === 0) {
            // Eğer product card'lar yoksa, page-search section'ını kullanarak tekrar dene
            const pageSearchUrl = `${window.MinimogSettings?.routes?.search_url || "/search"}?section_id=page-search&type=product&q=${queryString}`;
            
            return fetch(pageSearchUrl)
              .then((response) => response.text())
              .then((text) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, "text/html");
                const searchResults = doc.querySelector(".m-search-result");
                
                if (searchResults) {
                  const productCards = searchResults.querySelectorAll(".m-product-card");
                  
                  if (productCards.length > 0) {
                    this.renderProductCards(productCards, tabElement, queryString);
                    return;
                  }
                }
              })
              .catch((e) => {
                // Silent fail
              });
          }
          
          this.renderProductCards(allProductCards, tabElement, queryString);
        })
        .catch((e) => {
          // Silent fail
        });
    }

    renderProductCards(allProductCards, tabElement, queryString) {
      const desktopContainer = tabElement.querySelector("[data-recently-viewed-container]");
      const mobileContainer = tabElement.querySelector("[data-recently-viewed-container-mobile]");
      const mobileWrapper = mobileContainer?.querySelector(".m-product-tabs-mobile-scroll__wrapper");

      // Query string'den ürün ID'lerini çıkar (en son bakılan önce)
      const productIds = queryString.split(" OR ").map(q => q.replace("id:", "").trim());
      
      // Product card'ları query string sırasına göre sırala
      // Her product card'ın data-product-id attribute'unu kontrol et veya URL'den ID'yi bul
      const sortedCards = Array.from(allProductCards).sort((a, b) => {
        // Önce data-product-id attribute'unu kontrol et
        const idA = a.dataset.productId || a.getAttribute("data-product-id");
        const idB = b.dataset.productId || b.getAttribute("data-product-id");
        
        if (idA && idB) {
          const indexA = productIds.indexOf(idA.toString());
          const indexB = productIds.indexOf(idB.toString());
          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }
        }
        
        // Eğer data-product-id yoksa, URL'den handle'ı çıkar ve ID ile eşleştirmeyi dene
        // Bu durumda search endpoint'inin döndürdüğü sırayı kullan (zaten doğru sırada olmalı)
        return 0;
      });

      // Desktop container'a içerik ekle
      if (desktopContainer) {
        const productsPerRow = parseInt(tabElement.dataset.productsPerRow) || 3;
        const shouldEnableSlider = sortedCards.length > productsPerRow;
        
        sortedCards.forEach((card) => {
          const clonedCard = card.cloneNode(true);
          if (desktopContainer.classList.contains("swiper-wrapper") || shouldEnableSlider) {
            // Slider için swiper-slide wrapper ekle
            if (!desktopContainer.classList.contains("swiper-wrapper")) {
              desktopContainer.classList.add("swiper-wrapper");
              const wrapper = desktopContainer.closest(".m-mixed-layout__wrapper");
              if (wrapper && !wrapper.classList.contains("swiper-container")) {
                wrapper.classList.add("swiper-container");
              }
            }
            const slide = document.createElement("div");
            slide.className = "swiper-slide m:column";
            slide.appendChild(clonedCard);
            desktopContainer.appendChild(slide);
          } else {
            // Grid layout için direkt ekle
            desktopContainer.appendChild(clonedCard);
          }
        });
        
        // Slider kontrolünü güncelle
        if (shouldEnableSlider) {
          tabElement.dataset.enableSlider = "true";
        }
      }

      // Mobil container'a içerik ekle
      if (mobileWrapper) {
        sortedCards.forEach((card) => {
          const productLink = card.querySelector("a[href*='/products/']");
          if (!productLink) return;

                const href = productLink.getAttribute("href");
                const productMedia = card.querySelector(".m-product-card__media");
                const productImage = productMedia?.querySelector("img");
                const responsiveImage = productMedia?.querySelector("responsive-image");
                const productTitle = card.querySelector(".m-product-card__title a, .m-product-card__name");
                const productPrice = card.querySelector(".m-product-card__price");

                const title = productTitle?.textContent?.trim() || productLink.getAttribute("aria-label") || "";
                
                // Sadece fiyat değerini al (etiketleri değil)
                let price = "";
                if (productPrice) {
                  // Önce sale price'ı kontrol et, yoksa regular price'ı al
                  const salePrice = productPrice.querySelector(".m-price-item--sale");
                  const regularPrice = productPrice.querySelector(".m-price-item--regular");
                  
                  if (salePrice) {
                    price = salePrice.textContent?.trim() || "";
                  } else if (regularPrice) {
                    price = regularPrice.textContent?.trim() || "";
                  } else {
                    // Eğer class'lar yoksa, tüm price item'larından ilkini al
                    const priceItem = productPrice.querySelector(".m-price-item");
                    price = priceItem?.textContent?.trim() || "";
                  }
                }
                
                let imageHtml = "";
                if (responsiveImage) {
                  imageHtml = responsiveImage.outerHTML;
                } else if (productImage) {
                  const imageSrc = productImage.getAttribute("src") || productImage.getAttribute("data-src") || "";
                  const imageAlt = productImage.getAttribute("alt") || title;
                  const imageSrcset = productImage.getAttribute("srcset") || "";
                  imageHtml = `
                    <div class="m-product-card__main-image">
                      <responsive-image class="m-image" style="--aspect-ratio: 240 / 350">
                        <img src="${imageSrc}" ${imageSrcset ? `srcset="${imageSrcset}"` : ""} alt="${imageAlt}" loading="lazy" fetchpriority="low" class="m:w-full m:h-full" sizes="240px" />
                      </responsive-image>
                    </div>
                  `;
                } else {
                  imageHtml = `
                    <div style="--aspect-ratio: 240 / 350">
                      <svg class="m-placeholder-svg" viewBox="0 0 525 525" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="525" height="525" fill="#F3F3F3"/>
                      </svg>
                    </div>
                  `;
                }

                const mobileItem = document.createElement("div");
                mobileItem.className = "m-product-tabs-mobile-scroll__item";
                mobileItem.innerHTML = `
                  <div class="m-product-card m-product-card--style-1">
                    <div class="m-product-card__media">
                      <a class="m-product-card__link m:block m:w-full" href="${href}" aria-label="${title}">
                        ${imageHtml}
                      </a>
                    </div>
                    <div class="m-product-card__content m:text-left">
                      <div class="m-product-card__info">
                        <h3 class="m-product-card__title">
                          <a href="${href}" class="m-product-card__name">${title}</a>
                        </h3>
                        ${price ? `
                          <div class="m-product-card__price">
                            <span class="m-price-item m-price-item--regular">${price}</span>
                          </div>
                        ` : ""}
                      </div>
                    </div>
                  </div>
                `;
          mobileWrapper.appendChild(mobileItem);
        });
      }

      // Slider'ı yeniden başlat - ürün sayısına göre dinamik olarak
      const productsPerRow = parseInt(tabElement.dataset.productsPerRow) || 3;
      const shouldEnableSlider = sortedCards.length > productsPerRow;
      
      if (shouldEnableSlider || this.sliderEnabled) {
        setTimeout(() => {
          this.initSliderByScreenSize(tabElement);
        }, 100);
      }

      // Wishlist ve Compare butonlarını güncelle
      MinimogTheme.CompareProduct?.setCompareButtonsState();
      MinimogTheme.Wishlist?.setWishlistButtonsState();
    }

    getRecentlyViewedQueryString(tabElement) {
      const cookieName = "minimog-recently-viewed";
      const storedData = window.localStorage.getItem(cookieName);
      
      let items = JSON.parse(storedData || "[]");
      
      // Eğer localStorage'da ürün yoksa, boş string döndür
      if (!items || items.length === 0) {
        return "";
      }
      
      const currentProductId = tabElement.dataset.productId ? parseInt(tabElement.dataset.productId) : null;
      const productsToShow = tabElement.dataset.productsToShow ? parseInt(tabElement.dataset.productsToShow) : 6;
      
      // Mevcut ürünü listeden kaldır (kendi ürün sayfasında gösterilmemeli)
      if (currentProductId && items.includes(currentProductId)) {
        items = items.filter(item => item !== currentProductId);
      }
      
      // Eğer mevcut ürünü kaldırdıktan sonra liste boşaldıysa, boş string döndür
      if (!items || items.length === 0) {
        return "";
      }
      
      // En son bakılan ürünler önce gösterilsin (localStorage'da zaten unshift ile başa ekleniyor)
      // Bu yüzden sıralama doğru: [en yeni, ..., en eski]
      const queryString = items
        .map((item) => "id:" + item)
        .slice(0, productsToShow)
        .join(" OR ");
      
      return queryString;
    }
  }
  customElements.define("m-product-tabs", MProductTabs);
}
